import {Expose} from 'class-transformer';

export class AnnexReject {
    @Expose({name: 'uwr_comment'})
    uwrComment: string = null;

    constructor(props: Partial<AnnexReject> = {}) {
        Object.assign(this, props);
    }
}
